import React, { FCC } from 'react';
import { default as ReactLazyLoad, LazyLoadProps } from 'react-lazyload';
import { ILazyLoadProps } from './types';

const DEFAULT_PROPS: Partial<LazyLoadProps> = {
  once: true,
  resize: true,
  scroll: true,
  unmountIfInvisible: false,
};

export const LazyLoad: FCC<ILazyLoadProps> = (props) => {
  const fullProps = Object.assign({}, DEFAULT_PROPS, props) as LazyLoadProps;

  return <ReactLazyLoad {...fullProps} />;
};
